module.exports = "https://web-assets-production.autolist.com/_next/static/images/fresno-ca-19a3aa3f19f4f2258c2de3098bd303e9.jpg";